import React, { Fragment } from "react";
import styled, { css } from "styled-components";
import { ICON_RED_MINUS_SRC, ListIcon } from "../../../resources/Assets";
import { CardIconImg } from "../../../resources/CardIcon";
import CommonNoticeText from "../../../views/common/NoticeText/CommonNoticeText";

/*
  props
  state, R_Icon, L_Icon
  , title, subText, clickEvent
*/
const ListBtn = props => {
  // const viewData = ListTextData;
  const viewData = props.data;

  return (
    <Container status={viewData.STATUS} short={viewData.CONTAINER_SHORT}>
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          gap: "16px",
          flex: "auto",
        }}
        onClick={
          viewData.ACTION_ALL ? viewData.ACTION_ALL : e => e.preventDefault()
        }>
        {/* HEAD START */}
        <Header>
          <H_Title>
            {/* left */}
            {viewData.L_ICON && (
              // <L_Icon>
              //   <L_Icon_Img src={viewData.L_ICON} />
              // </L_Icon>
              <div
                style={
                  {
                    // width: "32px",
                    // height: "32px",
                    // textAlign: "center",
                    // lineHeight: "42px",
                  }
                }>
                {viewData.L_ICON}
              </div>
            )}
            {/* center */}
            <H_Body>
              <H_Body_Title>{viewData.TITLE}</H_Body_Title>

              {viewData.SUB_TEXT && (
                <H_Body_Subs>
                  <H_Body_Subs_Text status={viewData.SUB_TEXT.status}>
                    {viewData.SUB_TEXT.text}
                  </H_Body_Subs_Text>
                </H_Body_Subs>
              )}
            </H_Body>
          </H_Title>
          {/* right */}
        </Header>

        {/* HEAD END */}

        {/* BODY START */}
        {viewData.Body && <Fragment>{viewData.Body}</Fragment>}
        {/* BODY END */}

        {/* BOTTOM START */}
        {/* BOTTOM END */}
        {viewData.ps && (
          <PostScript>
            <CommonNoticeText title={viewData.ps} psIcon={true} text="" />
          </PostScript>
        )}
      </div>
      {viewData.R_ICON && viewData.R_ICON != "" && (
        <R_Icon
          Bg={viewData.R_ICON}
          onClick={viewData.ACTION ? viewData.ACTION : e => e.preventDefault()}
        />
      )}
    </Container>
  );
};

const ListTextData = {
  STATUS: "default",
  L_ICON: ListIcon.RECEIPT.L_ICON.TIME,
  TITLE: "Title",
  SUB_TEXT: {
    status: "default",
    text: "sub text",
  },
  R_ICON: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
  ACTION: "",
};

const Container = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  flex: auto;
  min-height: 72px;
  padding: ${props => (props.short ? "0px" : "16px")} 16px;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  border-radius: 10px;

  background: ${props =>
    props.status === "default" || props.status === "active"
      ? "#f8f7fa"
      : "#EDEDF0"};

  ${props =>
    props.status === "active"
      ? css`
          border: 1px solid var(--Primary, #6b65de);
        `
      : css`
          border: 1px solid #f3f2f5;
        `}

  ${props =>
    props.status === "disable" &&
    css`
      opacity: 0.6;
    `}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
`;

const H_Title = styled.div`
  display: flex;
  align-items: center;
  /* gap: 12px; */
  gap: 16px;
  flex: 1 0 0;
`;

const H_Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`;

const H_Body_Title = styled.div`
  align-self: stretch;
  color: #333;

  /* Title/3/SemiBold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.28px;
`;

const H_Body_Subs = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const H_Body_Subs_Text = styled.div`
  color: ${
    props => (props.status === "default" ? "#888" : "var(--red-400, #FF6259)")
    // : props.status === "error" ? "var(--red-400, #FF6259)"
  };

  /* Body/3/Regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;
`;

const L_Icon = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 5.333px;
  justify-content: center;
  align-items: center;
`;

const L_Icon_Img = styled.img`
  /* width: 25px; */
  /* height: 24.887px; */
  flex-shrink: 0;
  /* background: url(${props => props.Bg});
  background-repeat: no-repeat;
  background-position: center center; */
`;

const R_Icon = styled.div`
  width: 14px;
  height: 14px;
  background: url(${props => props.Bg});
`;

const Body = styled.div`
  display: flex;
  width: 288px;
  padding: 8px 16px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 6px;
  background: #fff;

  color: #888;

  /* Body/3/Regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;

  flex: 1 0 0;
`;

const PostScript = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;

export default ListBtn;
